import { render, staticRenderFns } from "./esitamition.vue?vue&type=template&id=63859f13&scoped=true&"
import script from "./esitamition.vue?vue&type=script&lang=ts&"
export * from "./esitamition.vue?vue&type=script&lang=ts&"
import style0 from "./esitamition.vue?vue&type=style&index=0&id=63859f13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63859f13",
  null
  
)

export default component.exports